import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { useBrandConfiguration } from '@search/core/brands/context';
import { MapListButtonGroup as CoreMapListButtonGroup } from '@search/core/components/MapListButtonGroup';
import { useAppContext } from '../../contexts/AppContext';
import { useLoaded } from '../../hooks/useLoaded';
import { useMapListButton } from '../../hooks/useMapListButton';
export const MapListButtonGroup = () => {
    const [searchModel, order, page] = useAppContext((store) => [store.searchModel, store.order, store.page]);
    const { defaultOrder } = useBrandConfiguration();
    const shouldDisplay = useMapListButton();
    const isLoaded = useLoaded();
    const isDisplayed = isLoaded && searchModel && shouldDisplay;
    // Display a box (withResponsive display) in order to prevent horizontal layout shift in desktop view
    return isDisplayed ? (_jsx(Box, { display: { 'breakpoint.base': 'none', 'breakpoint.md': 'block' }, children: _jsx(CoreMapListButtonGroup, { view: "list", searchModel: searchModel, order: order, page: page, defaultOrder: defaultOrder }) })) : (_jsx(Box, { as: "pre", display: { 'breakpoint.base': 'none', 'breakpoint.md': 'block' } }));
};
